import React, { useState, useEffect } from 'react';
import Svg from '../../../component/common/Svg'

export default function NestedMenuToggle() {
    const [addClass, setAddClass] = useState(false);
    // Function to toggle the class on the body element
    const toggleNestedBodyClass = () => {
        setAddClass(!addClass);
    };

    // Use useEffect to add or remove the class when addClass changes
    useEffect(() => {
        if (addClass) {
            document.body.classList.add('nested-sidebar-open');
        } else {
            document.body.classList.remove('nested-sidebar-open');
        }

        // Clean up the effect when the component unmounts
        return () => {
            document.body.classList.remove('nested-sidebar-open');
        };
    }, [addClass]);
    return (
        <>
            <button className="nested-sideb-toggle d-lg-none" onClick={toggleNestedBodyClass}>
                <span className="hamburger hamburger-1" />
                <span className="hamburger hamburger-2" />
                <span className="hamburger hamburger-3" />
            </button>
            <div className="body-overlay-nested" onClick={toggleNestedBodyClass} />
        </>
    )
}
